// extracted by mini-css-extract-plugin
export var cancelButton = "_nf-5";
export var content = "_nf-3";
export var createButton = "_nf-6";
export var drawerContainer = "_nf-0";
export var footer = "_nf-2";
export var header = "_nf-1";
export var orderFormColumn = "_nf-4";